import './image.css'
import Map from "../../../assets/media/about/imageMap/Map.svg"
import pinImage from "../../../assets/media/about/imageMap/pins.svg"
import Pakistan from "../../../assets/media/about/imageMap/Pakistan.svg"
import Canada from  "../../../assets/media/about/imageMap/Canada.svg"
import Singapore from  "../../../assets/media/about/imageMap/Singapore.svg"


const ImageMap = () => {
    return (
        <div className="locations lg:bg-[#333333] flex flex-col items-center pt-8 pb-5">
            <h4 className='text-[24px] font-bold 2xl:text-[44px] lg:text-[30px] xl:text-[40px] 2xl:leading-[24px] 2xl:mt-10 lg:text-[#FED80A]'>Our Locations</h4>
            <p className='text-[18px] mt-2 lg:mt-0 leading-[30px] lg:text-[24px] lg:leading-[36px] sm:w-[40rem] text-center md:text-[24px]  xl:text-[24px] 2xl:leading-[54px] 2xl:w-[35rem] 2xl:mt-5 lg:text-[#FED80A]'>We are headquatered in <span>Canada</span> with offices in <span>Singapore</span> and <span> Pakistan</span></p>

            <div className='map--image-wrapper'>
                <div className='map--image'>
                    <img src={Map} alt='map'  />
                    <div className='pin--image canada--img'>
                        <div className='pin--image-wrapper'>
                            <img src={pinImage} alt="marker"/>
                        </div>

                        <div className='content--img'>
                            <img src={Canada} alt='content'  />
                        </div>
                    </div>

                    <div className='pin--image pakistan-img'>
                        <div className='pin--image-wrapper'>
                            <img src={pinImage} alt="marker" />
                        </div>

                        <div className='content--img'>
                            <img src={Pakistan} alt='content' />
                        </div>
                    </div>


                    <div className='pin--image singapore-img'>
                        <div className='pin--image-wrapper'>
                            <img src={pinImage} alt="marker" />
                        </div>

                        <div className='content--img'>
                            <img src={Singapore} alt='content' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="maprouter w-full mt-5">
                <div className="gmap_canvas">
                    <iframe
                        title='iframe'
                        className="gmap_iframe w-full h-[15rem]"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2773.4993658704493!2d-66.64181458457564!3d45.96128477910991!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ca4195fdd4d9b57%3A0x6303ebfe1499e9d4!2sThe%20Talent%20Games!5e0!3m2!1sen!2s!4v1673942094493!5m2!1sen!2s"
                    />
                </div>
            </div>
        </div>
    )
}

export default ImageMap